import Vue from 'vue'
import { EventBus } from "./components/AudioPlayer";
import * as alert from "./utils/alert";
import * as biz from "./utils/biz";

// 모바일(안드로이드/아이폰)에서 호출하는 함수 by billy
export default function() {

	// 실행 되는지 확인을 위한 Test Code by billy...
	// setTimeout(() => {
	// 	EventBus.$emit('initcourseinfo', 34095);
	// }, 50)


	// 실제 호출될 함수
	window.showcourseinfo = (params)=>{
		// console.log(params);

		const courseNo = params;

		// alert.alert("initcourseinfo :"+courseNo, "확인");

		EventBus.$emit('initcourseinfo', courseNo, true);

		// biz.playAudioPlayer(courseNo, true);
	}

	window.EndPlayer = ()=>{
		EventBus.$emit('playend');
	}

	window.registGuide = ()=> {
		document.querySelector('ion-alert-controller').create({
			message: "앗! 정회원이 아니시군요 ㅠㅠ\n<b>이 동화는 정회원만 이용할 수 있어요.</b>\n지금 바로 이용권을 구매하고\n초중등 전학년 전과목 모든 콘텐츠를 무제한\n이용할 수 있는 <b>정회원만의 특별한 혜택</b>을 누려보세요!",
			buttons: [
				{
					text: '다음번에 할래요',
					role: 'cancel',
					cssClass: 'secondary',
					handler: () => {
						// console.log('Confirm Cancel');
					},
				},
				{
					text: '이용권 종류 보러가기',
					handler: () => {
						window.location = "/mypage/ticket";
					},
				},
			],
			mode: "ios"
		}).then(alert => {
			alert.present();
		});
	}

	window.registGuide2 = ()=> {
		document.querySelector('ion-alert-controller').create({
			message: "<b>2분 미리듣기가 완료되었습니다.</b>\n\n앗! 정회원이 아니시군요 ㅠㅠ\n<b>이 동화는 정회원만 이용할 수 있어요.</b>\n지금 바로 이용권을 구매하고\n초중등 전학년 전과목 모든 콘텐츠를 무제한\n이용할 수 있는 <b>정회원만의 특별한 혜택</b>을 누려보세요!",
			buttons: [
				{
					text: '다음번에 할래요',
					role: 'cancel',
					cssClass: 'secondary',
					handler: () => {
						// console.log('Confirm Cancel');
					},
				},
				{
					text: '이용권 종류 보러가기',
					handler: () => {
						window.location = "/mypage/ticket";
					},
				},
			],
			mode: "ios"
		}).then(alert => {
			alert.present();
		});
	}

	window.registGuideFree = ()=> {
		document.querySelector('ion-alert-controller').create({
			message: "이어지는 동화는 사용 중인 이용권이 있어야 들을 수 있습니다.\n더 많은 동화를 들어보고 싶으시다구요?\n<b>지금 가입하고 듣는동화를 즐겨보세요!\n듣는동화 회원이신가요? <a href='/login'>로그인하기</a>",
			buttons: [
				{
					text: '다음번에 할래요',
					role: 'cancel',
					cssClass: 'secondary',
					handler: () => {
						// console.log('Confirm Cancel');
					},
				},
				{
					text: '회원가입하러 가기',
					handler: () => {
						window.location = "/member/join/step2";
					},
				},
			],
			mode: "ios"
		}).then(alert => {
			alert.present();
		});
	}

}
